/* 88 Acres collection template behaviour (sections/main-collection-88, collection-details-88).
   - <c88-buy>: One-time / Subscribe & Save switch on each product card. The frequency
     <select name="selling_plan"> is only enabled (so only submitted) in subscribe mode.
     The form is a normal /cart/add form. On Horizon the submit handler below adds it through
     Shopify.actions.updateCart (variant, quantity, selling plan) so Horizon's cart drawer
     re-renders and opens; without the actions bundle the form posts to /cart/add as usual.
   - Show more, sort select and Read more toggles. */
(function () {
  'use strict';
  if (window.__c88Loaded) return;
  window.__c88Loaded = true;

  var mobile = window.matchMedia('(max-width: 749px)');

  class C88Buy extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.one = this.querySelector('[data-c88-one]');
      this.sub = this.querySelector('[data-c88-sub]');
      this.plan = this.querySelector('[data-c88-plan]');
      this.ctaPrice = this.querySelector('[data-c88-cta-price]');
      var card = this.closest('.c88-card');
      this.cardPrice = card ? card.querySelector('[data-c88-price]') : null;
      if (this.one) this.one.addEventListener('click', () => this.setMode('one'));
      if (this.sub) this.sub.addEventListener('click', () => {
        /* On mobile the subscribe control works like a checkbox */
        if (this.dataset.mode === 'sub' && mobile.matches && this.dataset.locked !== 'true') this.setMode('one');
        else this.setMode('sub');
      });
      /* No subscription: Buy 1 / Buy 2 quantity boxes */
      this.qtyInput = this.querySelector('[data-c88-qty-input]');
      this.qtyBtns = Array.prototype.slice.call(this.querySelectorAll('[data-c88-qty]'));
      if (this.qtyBtns.length) {
        this.qtyBtns.forEach((b) => b.addEventListener('click', () => this.setQty(b)));
        this.setQty(this.qtyBtns[0]);
        return;
      }
      this.setMode(this.dataset.mode || 'one');
    }

    setQty(btn) {
      this.qtyBtns.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      if (this.qtyInput) this.qtyInput.value = btn.getAttribute('data-c88-qty');
      var total = btn.getAttribute('data-total') || '';
      var was = btn.getAttribute('data-was') || '';
      if (this.ctaPrice) this.ctaPrice.textContent = ' · ' + total;
      if (this.cardPrice) {
        this.cardPrice.textContent = '';
        if (was && was !== total) {
          var s = document.createElement('s');
          s.textContent = was;
          this.cardPrice.appendChild(s);
        }
        this.cardPrice.appendChild(document.createTextNode(total));
      }
    }

    setMode(mode) {
      if (this.dataset.locked === 'true') mode = 'sub';
      this.dataset.mode = mode;
      var isSub = mode === 'sub';
      if (this.one) this.one.setAttribute('aria-pressed', isSub ? 'false' : 'true');
      if (this.sub) this.sub.setAttribute('aria-pressed', isSub ? 'true' : 'false');
      if (this.plan) {
        this.plan.disabled = !isSub;
        this.plan.tabIndex = isSub ? 0 : -1;
      }
      var price = this.dataset.price || '';
      var compare = this.dataset.compare || '';
      var subPrice = this.dataset.subPrice || price;
      if (this.ctaPrice) this.ctaPrice.textContent = ' · ' + (isSub ? subPrice : price);
      if (this.cardPrice) {
        /* Struck-through price: the compare-at price when the item is on sale, else the regular price */
        var was = isSub ? (compare || price) : compare;
        var now = isSub ? subPrice : price;
        this.cardPrice.textContent = '';
        if (was && was !== now) {
          var s = document.createElement('s');
          s.textContent = was;
          this.cardPrice.appendChild(s);
        }
        this.cardPrice.appendChild(document.createTextNode(now));
      }
    }
  }
  if (!customElements.get('c88-buy')) customElements.define('c88-buy', C88Buy);

  document.addEventListener('click', function (e) {
    var more = e.target.closest && e.target.closest('[data-c88-more]');
    if (more) {
      var grid = document.getElementById(more.getAttribute('aria-controls'));
      if (grid) {
        grid.classList.add('is-expanded');
        var first = grid.querySelector('.c88-card--more .card-88__title a');
        more.closest('.c88-more').style.display = 'none';
        if (first) first.focus({ preventScroll: true });
      }
      return;
    }
    var rm = e.target.closest && e.target.closest('[data-c88-readmore]');
    if (rm) {
      var box = document.getElementById(rm.getAttribute('aria-controls'));
      if (!box) return;
      var open = !box.classList.contains('is-open');
      box.classList.toggle('is-open', open);
      rm.setAttribute('aria-expanded', open ? 'true' : 'false');
      rm.textContent = open ? rm.getAttribute('data-less') : rm.getAttribute('data-more');
    }
  });

  document.addEventListener('change', function (e) {
    var sort = e.target.closest && e.target.closest('[data-c88-sort]');
    if (!sort) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* Horizon: add the card's form through the cart actions so the drawer updates and opens */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('c88-buy form');
    if (!form || !window.Shopify || !Shopify.actions || !Shopify.actions.updateCart) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    var line = { merchandiseId: form.elements.id.value, quantity: Number(form.elements.quantity.value) || 1 };
    var plan = form.elements.selling_plan;
    if (plan && !plan.disabled && plan.value) line.sellingPlanId = plan.value;
    btn.setAttribute('aria-busy', 'true');
    Shopify.actions.updateCart({ lines: [line] }, { event: { context: 'product' } })
      .then(function () { return Shopify.actions.openCart(); })
      .catch(function () { HTMLFormElement.prototype.submit.call(form); })
      .then(function () { btn.removeAttribute('aria-busy'); });
  });

  /* Hide "Read more" when the copy is short enough to show in full */
  function initClamps() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-c88-clamp]'), function (box) {
      var btn = document.querySelector('[aria-controls="' + box.id + '"]');
      if (btn && box.scrollHeight <= box.clientHeight + 4) { box.classList.add('is-open'); btn.hidden = true; btn.style.display = 'none'; }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initClamps);
  else initClamps();
  document.addEventListener('shopify:section:load', initClamps);
})();
